import { useQuery } from '@tanstack/react-query';
import { getQueryKey, validateCompanyShareToken } from './queryFn';

export const useValidateCompanyShareToken = (
  token: string,
  companyId: string | undefined
) => {
  const { data, status, fetchStatus } = useQuery({
    queryKey: getQueryKey(token, companyId ?? ''),
    queryFn: validateCompanyShareToken,
    staleTime: Infinity,
    retry: 1,
    refetchOnMount: false,
    enabled:
      typeof token === 'string' &&
      token !== '' &&
      typeof companyId === 'string',
    refetchOnWindowFocus: false,
  });
  if (status === 'success') {
    return {
      isValidShareToken: data.isValidShareToken,
      logo: data.logo ?? '',
      status,
      fetchStatus,
    };
  }
  return { isValidShareToken: false, status, fetchStatus };
};
